<template>
  <div>
    <router-link :to="getRoute()">
      <div
        class="pointer-events-none fixed right-0 top-0 mt-24 w-full items-end justify-center px-4 py-6 xs:max-w-md sm:items-start sm:justify-end sm:p-6 md:mt-16"
        style="z-index: 99 !important"
      >
        <div class="pointer-events-auto w-full rounded-lg bg-white shadow-lg">
          <div class="shadow-xs overflow-hidden">
            <div class="px-5 py-4">
              <div class="flex items-start">
                <div class="pt-1 text-center text-base text-secondary-500">
                  <svg
                    v-if="
                      notification.type === 0 || notification.type === 9 || notification.type === 10
                    "
                    class="mx-auto h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fad"
                    data-icon="calendar-day"
                    role="img"
                    viewBox="0 0 448 512"
                  >
                    <g class="fa-group">
                      <path
                        class="fa-secondary"
                        fill="currentColor"
                        d="M0 192v272a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V192zm192 176a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16v-96a16 16 0 0 1 16-16h96a16 16 0 0 1 16 16zm112-240h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16zm-192 0h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16z"
                        opacity="0.4"
                      />
                      <path
                        class="fa-primary"
                        fill="currentColor"
                        d="M448 112v80H0v-80a48 48 0 0 1 48-48h48v48a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V64h128v48a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V64h48a48 48 0 0 1 48 48z"
                      />
                    </g>
                  </svg>
                  <svg
                    v-if="notification.type === 1"
                    class="mx-auto h-6 w-6 fill-current text-yellow-400"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                  >
                    <path
                      class="fa-primary"
                      d="M335.9 371c-9.715 8.604-15.9 20.65-15.9 33.62C319.1 428.7 339.3 448 363.4 448h4.644c26.51 0 47.99 21.49 47.99 48c0 8.836-7.162 16-15.1 16H176c-8.836 0-15.1-7.164-15.1-16c0-26.51 21.48-48 47.99-48h4.644c24.03 0 43.36-19.33 43.36-43.35c0-12.98-6.184-25.02-15.9-33.62C128 271.7 128 96 128 96L128 32c0-17.67 14.5-32 32.17-32h255.7C433.5 0 448 14.33 448 32l-.0059 64C447.1 96 447.1 271.7 335.9 371z"
                    />
                    <path
                      class="fa-secondary"
                      d="M193.7 316.9C189.8 311.1 186.2 305.3 182.8 299.4c-47.14-19.35-82.56-45.83-105.4-79.52C49.47 178.6 47.01 135.7 48.38 112h80.39C128.1 101.9 128 96 128 96L128.1 64H27.26C16.16 64 6.537 71.59 3.912 82.38C3.1 85.78-15.71 167.2 37.07 245.9c37.45 55.82 100.6 95.03 187.5 117.4c8.828 2.268 17.76 9.74 15.51 7.75C211.9 346 194.2 317.4 193.7 316.9zM572.1 82.38C569.5 71.59 559.8 64 548.7 64h-100.8l.0811 32c0 0-.0953 5.926-.7652 16h80.39c1.375 23.66-1.093 66.63-29.03 107.8c-22.82 33.69-58.25 60.17-105.4 79.52c-3.402 5.91-7.023 11.73-10.86 17.5c-.5352 .5352-18.2 29.14-46.45 54.16c-2.248 1.99 6.687-5.482 15.51-7.75c86.96-22.34 150.1-61.55 187.5-117.4C591.7 167.2 572.9 85.78 572.1 82.38z"
                    />
                  </svg>
                  <svg
                    v-if="notification.type === 2"
                    class="mx-auto h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fad"
                    data-icon="user-friends"
                    role="img"
                    viewBox="0 0 640 512"
                  >
                    <g class="fa-group">
                      <path
                        class="fa-secondary"
                        fill="currentColor"
                        d="M480 256a96 96 0 1 0-96-96 96 96 0 0 0 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592a48 48 0 0 0 48-48 111.94 111.94 0 0 0-112-112z"
                        opacity="0.4"
                      />
                      <path
                        class="fa-primary"
                        fill="currentColor"
                        d="M192 256A112 112 0 1 0 80 144a111.94 111.94 0 0 0 112 112zm76.8 32h-8.3a157.53 157.53 0 0 1-68.5 16c-24.6 0-47.6-6-68.5-16h-8.3A115.23 115.23 0 0 0 0 403.2V432a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48v-28.8A115.23 115.23 0 0 0 268.8 288z"
                      />
                    </g>
                  </svg>
                  <svg
                    v-if="notification.type === 3"
                    class="mx-auto h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fad"
                    data-icon="user"
                    role="img"
                    viewBox="0 0 448 512"
                  >
                    <g class="fa-group">
                      <path
                        class="fa-secondary"
                        fill="currentColor"
                        d="M352 128A128 128 0 1 1 224 0a128 128 0 0 1 128 128z"
                        opacity="0.4"
                      />
                      <path
                        class="fa-primary"
                        fill="currentColor"
                        d="M313.6 288h-16.7a174.1 174.1 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48v-41.6A134.43 134.43 0 0 0 313.6 288z"
                      />
                    </g>
                  </svg>
                  <svg
                    v-if="notification.type === 4"
                    class="mx-auto h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fad"
                    data-icon="ticket-alt"
                    role="img"
                    viewBox="0 0 576 512"
                  >
                    <g class="fa-group">
                      <path
                        class="fa-secondary"
                        fill="currentColor"
                        d="M576 208v-96a48 48 0 0 0-48-48H48a48 48 0 0 0-48 48v96a48 48 0 0 1 0 96v96a48 48 0 0 0 48 48h480a48 48 0 0 0 48-48v-96a48 48 0 0 1 0-96zm-96 176H96V128h384z"
                        opacity="0.4"
                      />
                      <path
                        class="fa-primary"
                        fill="currentColor"
                        d="M480 128v256H96V128z"
                      />
                    </g>
                  </svg>
                  <svg
                    v-if="notification.type === 5"
                    class="mx-auto h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fad"
                    data-icon="money-check-edit"
                    role="img"
                    viewBox="0 0 640 512"
                  >
                    <g class="fa-group">
                      <path
                        class="fa-secondary"
                        fill="currentColor"
                        d="M640 192v288a32 32 0 0 1-32 32H32a32 32 0 0 1-32-32V192a32 32 0 0 1 32-32h171.06L331 288H104a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h259l64 64H104a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h456a16 16 0 0 0 16-16v-74.46a64 64 0 0 0-18.74-45.26L437 160h171a32 32 0 0 1 32 32z"
                        opacity="0.4"
                      />
                      <path
                        class="fa-primary"
                        fill="currentColor"
                        d="M534.64 302.91L303.18 71.47l-71.7 71.7 231.39 231.45a32 32 0 0 0 22.64 9.38H528a16 16 0 0 0 16-16v-42.46a32 32 0 0 0-9.36-22.63zM238.78 7a24.1 24.1 0 0 0-33.9 0L167 44.87a24 24 0 0 0 0 33.8l41.9 41.9 71.7-71.8z"
                      />
                    </g>
                  </svg>
                  <svg
                    v-if="
                      notification.type > 5 && notification.type !== 9 && notification.type !== 10
                    "
                    class="mx-auto h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="info-circle"
                    role="img"
                    viewBox="0 0 512 512"
                  >
                    <path
                      fill="currentColor"
                      d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
                    />
                  </svg>
                </div>
                <div class="ml-3 w-0 flex-1 pt-0.5">
                  <p class="text-sm font-medium leading-none text-secondary-500">
                    {{ notification.object.Title }}
                  </p>
                  <p class="mt-1 text-sm leading-tight text-gray-500">
                    {{ notification.object.Description }}
                  </p>
                </div>
                <div class="ml-4 flex shrink-0">
                  <button
                    class="inline-flex text-gray-400 transition duration-150 ease-in-out hover:text-gray-800 focus:text-gray-500 focus:outline-none"
                    @click="closePopup()"
                  >
                    <svg
                      class="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  components: {},

  props: {
    notification: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {};
  },

  methods: {
    getIcon() {
      switch (this.notification.type) {
        case 0:
          return 'fad fa-calendar-day';
        case 1:
          return 'fad fa-trophy';
        case 2:
          return 'fad fa-user-friends';
        case 3:
          return 'fad fa-user';
        case 4:
          return 'fad fa-ticket-alt';
        case 5:
          return 'fad fa-shekel-sign';
        default:
          return 'fad fa-info';
      }
    },

    getRoute() {
      switch (this.notification.type) {
        case 0:
          return '/bookings';
        case 9:
          return this.notification.object.ContextualId !== null
            ? this.notification.object.ContextualId.split('account.playmore.golf')[1]
            : '/';
        case 1:
          return '/trophies';
        case 2:
          return '/requests';
        case 3:
          return '/account';
        case 4:
          return '/account';
        case 5:
          return '';
        default:
          return '';
      }
    },

    closePopup() {
      this.$emit('click', false);
    },

    acceptBuddy() {
      this.$emit('acceptBuddy', this.notification.id);
      this.$emit('click', false);
    },

    declineBuddy() {
      this.$emit('declineBuddy', this.notification.id);
      this.$emit('click', false);
    },
  },
};
</script>
